var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function CameraIcon(_a) {
    var _b = _a.hideCircle, hideCircle = _b === void 0 ? false : _b, _c = _a.circleColor, circleColor = _c === void 0 ? '#E1E0E7' : _c, width = _a.width, height = _a.height, props = __rest(_a, ["hideCircle", "circleColor", "width", "height"]);
    var size = width || height || 37;
    return (React.createElement(Icon, __assign({ "data-icon": 'camera', width: size, height: size, viewBox: "0 0 37 37" }, props),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0H37V37H0z" }),
            React.createElement("ellipse", { cx: "18.15", cy: "18.202", fill: "#FFF", rx: "18.15", ry: "18.202" }),
            !hideCircle && React.createElement("circle", { cx: "18.15", cy: "18.202", r: "16", fill: circleColor }),
            React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M9.912 25.285h16.476c.918 0 1.662-.746 1.662-1.666v-9.464c0-.92-.744-1.666-1.662-1.666h-2.444c-.858 0-1.6-.6-1.783-1.442-.13-.602-.663-1.032-1.278-1.032h-5.466c-.615 0-1.147.43-1.278 1.032-.182.842-.925 1.442-1.784 1.442H9.912c-.441 0-.864.175-1.175.488-.312.312-.487.736-.487 1.178v9.464c0 .442.175.866.487 1.178.311.313.734.488 1.175.488zM25.49 13.747c.426 0 .81.257.973.652.163.395.072.849-.229 1.151-.3.302-.754.392-1.147.229-.394-.164-.65-.549-.65-.976 0-.28.11-.549.308-.747.197-.198.465-.31.745-.31zm-7.34-.312c2.021 0 3.843 1.22 4.616 3.093.774 1.873.346 4.028-1.083 5.461-1.429 1.433-3.578 1.862-5.445 1.086-1.867-.775-3.085-2.602-3.085-4.63.003-2.765 2.239-5.007 4.997-5.01zm-3.897 5.01c0-2.157 1.745-3.907 3.897-3.907 2.152 0 3.897 1.75 3.897 3.908s-1.745 3.908-3.897 3.908c-2.151-.003-3.894-1.75-3.897-3.908z" }))));
}
export default styled(CameraIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
